import { dropRight, last as takeLast, take } from 'lodash';
import React, { FC, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { useTranslation } from 'hooks/use-translation';

const Separator = styled.span`
  margin-left: calc(-1 * var(--spacing-02));
`;

export const ContainedList: FC<{
  items: ReactNode[];
  separator?: ReactNode;
  and?: ReactNode;
  show?: number;
}> = ({
  items: all,
  show = 2,
  separator = <Separator>,&nbsp;</Separator>,
  and = (
    <Separator>
      <FormattedMessage id="notifications.messages.items.and" />
    </Separator>
  ),
}) => {
  const count = all.length;
  const clamped_show = Math.max(1, show);
  const item = all[0];
  const rest = count > clamped_show ? count - clamped_show : 0;
  const to_show = take(all, clamped_show);
  const others = useTranslation('notifications.messages.items.others', {
    rest,
  });
  const except_last = (rest === 0 ? dropRight(to_show, 1) : to_show)
    .map((x, i) => (i === 0 ? [x] : [separator, x]))
    .reduce((items, with_separators) => items.concat(...with_separators), []);
  const last = rest === 0 ? takeLast(to_show) : others;

  return (
    <FormattedMessage
      id={`notifications.messages.items${count <= 1 ? '' : '.several'}`}
      values={{
        count,
        rest,
        item,
        except_last,
        last,
        and,
      }}
    />
  );
};
